import { useCallback, useEffect, useState } from 'react';
import api from '../config/api';

/**
 * Loads `{ history: [...] }` from a trip or package history endpoint.
 */
export default function useChangeHistory(endpoint, { enabled = true, requestConfig } = {}) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  const load = useCallback(async () => {
    if (!endpoint || !enabled) return;
    setLoading(true);
    setFailed(false);
    try {
      const response = await api.get(endpoint, requestConfig);
      const rows = response?.data?.history;
      setHistory(Array.isArray(rows) ? rows : []);
    } catch (error) {
      setFailed(true);
    } finally {
      setLoading(false);
    }
  }, [endpoint, enabled, requestConfig]);

  useEffect(() => {
    load();
  }, [load]);

  return { history, loading, failed, reload: load };
}
